// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25da198b","223":"90fb010f","453":"f37f12ab","455":"210cdc81"}[chunkId] + ".chunk.js";
};